module.exports = __webpack_public_path__ + "media/images/top/icon/blue/ico_top-09dd3ae1781c01bbd49eb4cef4a9c68d.svg";